import React from 'react';
import ThoughtBubble from './ThoughtBubble';
import './BubblesContainer.css';

const BubblesContainer = ({ 
  activeBubbles, 
  onBubbleClick, 
  onBubbleComplete 
}) => {
  return (
    <div className="bubbles-container">
      {activeBubbles.map((bubble, index) => (
        <ThoughtBubble
          key={bubble.instanceId}
          thought={bubble}
          onBubbleClick={onBubbleClick}
          onBubbleComplete={onBubbleComplete}
          initialPosition={bubble.position}
          isFirstBubble={index === 0}
          shouldFadeOut={bubble.shouldFadeOut}
        />
      ))}
    </div>
  );
};

export default BubblesContainer;

